import React, { useState, ReactNode } from 'react';
import { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';
import { useServiceRouter } from '@common/components/ServiceRouter';

import TestRulesModal from '../TestRulesModal';

interface RulesModalWrapperProps {
	lessonModel: IStudentLessonModel;
	goBack: () => void;
	isTestLesson: boolean;
	children: ReactNode;
}

function RulesModalWrapper({
	lessonModel, goBack, isTestLesson, children,
} :RulesModalWrapperProps) {
	const [showTestRulesModal, setShowTestRulesModal] = useState(true);
	const { checkService } = useServiceRouter();

	const handleAgree = () => {
		setShowTestRulesModal(false);
	};

	if (checkService('international') && isTestLesson && showTestRulesModal && lessonModel.gradebook.is_done === 0) {
		return (
			<TestRulesModal
				onClose={goBack}
				onAgree={handleAgree}
				isOpen={showTestRulesModal}
			/>
		);
	}

	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{children}
		</>
	);
}

export default RulesModalWrapper;
